import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CloseLoopFilter } from "./types";
import { MasterAccountSelect, ProviderPagedSelect } from "../../forms/selects";
import { DateInput, FormCheck, FormSelect, RangeInput } from "../../forms";
import { useHoFetchBusinessSheetStatusesQuery } from "../../../services/headofficeadmin";

const CloseLoopFilterForm = () => {

    const { control, setValue } = useFormContext<CloseLoopFilter>();
    const { data: statuses } = useHoFetchBusinessSheetStatusesQuery();

    return <div className="row gy-2">
        <div className="col-12 col-lg-6">
            <Controller
                control={control}
                name="masterAccountIds"
                render={({ field: { value } }) => (
                    <MasterAccountSelect
                        label="Master Account(s)"
                        value={value}
                        setValue={(selections: SelectOption<string>[]) => setValue('masterAccountIds', selections.map(s => s.value))}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                )}
            />
        </div>
        <div className="col-12 col-lg-6">
            <Controller
                control={control}
                name="providers"
                render={({ field: { value } }) => (
                    <ProviderPagedSelect
                        label="Provider(s)"
                        value={value}
                        setValue={(selections: SelectOption<string>[]) => setValue('providers', selections)}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                )}
            />
        </div>
        <div className="col-12 col-lg-6">
            <Controller
                control={control}
                name="applicationDate"
                render={({ field: { value } }) => (
                    <RangeInput
                        InputComponent={DateInput}
                        label="Application Date"
                        startProps={{
                            value: value?.from,
                            onBlur: (date: string) => setValue('applicationDate', { from: date, to: value?.to }),
                            maxDate: value?.to == null ? null : Date.parse(value.to)
                        }}
                        endProps={{
                            value: value?.to,
                            onBlur: (date: string) => setValue('applicationDate', { from: value?.from, to: date }),
                            minDate: value?.from == null ? null : Date.parse(value.from)
                        }}
                        disableAnimations
                        isClearable />
                )}
            />
        </div>
        <div className="col-12 col-lg-6">
            <Controller
                control={control}
                name="lastDealDate"
                render={({ field: { value } }) => (
                    <RangeInput
                        InputComponent={DateInput}
                        label="Last Deal"
                        startProps={{
                            value: value?.from,
                            onBlur: (date: string) => setValue('lastDealDate', { from: date, to: value?.to }),
                            maxDate: value?.to == null ? null : Date.parse(value.to)
                        }}
                        endProps={{
                            value: value?.to,
                            onBlur: (date: string) => setValue('lastDealDate', { from: value?.from, to: date }),
                            minDate: value?.from == null ? null : Date.parse(value.from)
                        }}
                        disableAnimations
                        isClearable
                    />
                )}
            />
        </div>
        <div className="col-12 col-md-6">
            <Controller
                control={control}
                name="statuses"
                render={({ field: { value } }) => (
                    <FormSelect
                        label="Status"
                        defaultValue={value}
                        options={statuses ?? []}
                        onBlur={(selections: SelectOption<number>[]) => setValue('statuses', selections.map(s => s.value))}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                )}
            />
        </div>
        <div className="col-12 col-lg-6">
            <Controller
                control={control}
                name="statusDate"
                render={({ field: { value } }) => (
                    <RangeInput
                        InputComponent={DateInput}
                        label="Status Date"
                        startProps={{
                            value: value?.from,
                            onBlur: (date: string) => setValue('statusDate', { from: date, to: value?.to }),
                            maxDate: value?.to == null ? null : Date.parse(value.to)
                        }}
                        endProps={{
                            value: value?.to,
                            onBlur: (date: string) => setValue('statusDate', { from: value?.from, to: date }),
                            minDate: value?.from == null ? null : Date.parse(value.from)
                        }}
                        disableAnimations
                        isClearable
                    />
                )}
            />
        </div>
        <div className="col-6 mt-3 col-lg-3">
            <Controller
                control={control}
                name="hasLogin"
                render={({ field: { value } }) => (
                    <FormCheck
                        isChecked={value}
                        label="Hide without Login"
                        onChange={() => setValue("hasLogin", !value)}
                        disableAnimations
                    />
                )}
            />
        </div>
        <div className="col-6 mt-3 col-lg-3">
            <Controller
                control={control}
                name="isAjBellAccount"
                render={({ field: { value } }) => (
                    <FormCheck
                        isChecked={value}
                        label="AJBS Only"
                        onChange={() => setValue("isAjBellAccount", !value)}
                        disableAnimations
                    />
                )}
            />
        </div>
    </div>;
};

export default CloseLoopFilterForm;